import { LegacyDevice } from 'console/device/device';
export function addDeviceID(selected_device_ids, device_id) {
    if (device_id === null)
        return selected_device_ids;
    if (selected_device_ids.length === 0)
        return [device_id];
    selected_device_ids.push(device_id);
    return selected_device_ids.filter((dev_id, index) => index === selected_device_ids.indexOf(dev_id));
}
export function findItem(devices, search) {
    const search_trim = search.trim();
    if (!search_trim)
        return devices;
    const search_lower = search_trim.toLowerCase();
    return devices.filter((dev) => LegacyDevice.display_name(dev).toLowerCase().indexOf(search_lower) !== -1);
}
